import React from 'react';
import PropTypes from 'prop-types';
import { MemoryAnswersV1 } from '../MemoryAnswersV1';
import { useAutoSubmitAnswer } from '../../shared/use-auto-submit-answer';
import styles from './TalkSlide.css';

const HEADING = 'You talk. We write.';
const DESCRIPTION = 'Speak or type, like you would to someone who just listens. We turn it into written pages in your voice. It’s private: nobody reads it unless you share it.';
const ANSWERS = [
    { id: 1, icon: 'microphone', text: 'Speak' },
    { id: 2, icon: 'keyboard', text: 'Type' },
    { id: 3, icon: 'shuffle', text: 'A bit of both' }
];

function TalkSlide({ id, spriteVersion, submitAnswer, submitTemporaryAnswer, userResponse = {}, delay }) {
    const { selectAnswer } = useAutoSubmitAnswer({ id, question: HEADING, userResponse, submitAnswer, submitTemporaryAnswer, delay });

    return (
        <section className={styles.form}>
            <h1 className={styles.heading}>{HEADING}</h1>
            <p className={styles.description}>{DESCRIPTION}</p>
            <MemoryAnswersV1
                answers={ANSWERS}
                selectedId={userResponse?.id}
                onSelect={selectAnswer}
                spriteVersion={spriteVersion}
                isWhite
            />
        </section>
    );
}

TalkSlide.propTypes = {
    id: PropTypes.number.isRequired,
    spriteVersion: PropTypes.string.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    delay: PropTypes.number
};

export {
    TalkSlide
};
